import { SearchOutlined } from "@material-ui/icons";
import styled from "styled-components";
const Info = styled.div`
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
  cursor: pointer;
`;

const Image = styled.img`
  height: 75%;
  z-index: 2;
`;

const Container = styled.div`
  flex: 1;
  margin: 5px;
  min-width: 280px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f1ed;
  /* border-radius: 5px; */
  position: relative;

  &:hover ${Info} {
    opacity: 1;
  }
`;

const Circle = styled.div`
  width: 100px;
  height: 100px;
  /* border-radius: 50%; */
  background-color: white;
  position: absolute;
`;

const Icon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  transition: all 0.5s ease;
  &:hover {
    background-color: #e9f5f5;
    transform: scale(1.1);
  }
`;

const Description = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0px;
  z-index: 5;

  text-align: center;
  backdrop-filter: blur(5px);
`;

const Product = ({ item }) => {
  return (
    <Container>
      <Circle />
      <Image src={item.img} />
      <Info>
        <Icon>
          <SearchOutlined />
        </Icon>
      </Info>
      <Description>
        <h4>{item.title}</h4>
        <p>{item.desc}</p>
      </Description>
    </Container>
  );
};

export default Product;
